import { Component, EventEmitter, input, OnInit, output } from '@angular/core';
import { StructureProgammatiqueService } from '../../../services/structureProgrammatiquesService';
import { StructureProgrammatiqueResponse } from '../../../data/http/responses/structureprogrammatique.res';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { routeAlias } from '../../../../routesalias';
import { AppService } from '../../../core/app.service';
import { SelectComponent } from '../../forms/select/select.component';
import { SelectOption } from '../../../data/schemas/selectoption.schema';
import { Input } from "../../forms/input/input";
import { TypeInterventionService } from '../../../services/typeintervention/typeintervention.service';
import { TypeInterventionResponse } from '../../../data/http/responses/typeintervention.response';
import { ParametrageStructureProgrammatiqueService } from '../../../services/typeintervention/parametragestructureprogrammatique.service';
import { ParametrageStructureProgrammatiqueResponse } from '../../../data/http/responses/parametragestructureprogrammatique.response';
//import { CommonModule, DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-steponeactivities',
  imports: [ReactiveFormsModule, SelectComponent, Input, RouterLink],
  templateUrl: './steponeactivities.component.html',
  styleUrl: './steponeactivities.component.css'
})
export class SteponeactivitiesComponent implements OnInit {

  // Flag to show a top-right validation alert when submit fails
  showValidationAlert: boolean = false;
  missingFields: string[] = [];
  taskWeightError: boolean = false;

  generalesData = input<any>();
  generalesChanges = output<any>();
  typeActivityChanged = output<boolean>();

  public typeInterventionData: TypeInterventionResponse[] = []
  public configuredActivityTypeId: string | null = null;
  //public structures: StructureProgrammatiqueResponse[] = [];
  public resultatStructures: SelectOption[] = [];
  public types: SelectOption[] = [];
  public generaleForm: FormGroup = new FormGroup({});

  public programme: StructureProgrammatiqueResponse | null = null;
  public objectif: StructureProgrammatiqueResponse | null = null;
  public taches: any[] | null = null; // Gardez cette propriété pour afficher les tâches initiales

  public loadingTypes = false;
  public loadingStructures = false;

  public programmes: SelectOption[] = [];
  public currentDescendants: any[] = [];
  public loadingProgrammeSelect = false;

  private subscription: Subscription = new Subscription()

  constructor(
    private structureProgrammatiqueService: StructureProgammatiqueService,
    private typeInterventionService: TypeInterventionService,
    private parametrageStructureProgrammatiqueService: ParametrageStructureProgrammatiqueService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService
  ) {
    this.generaleForm = this.fb.group({
      programmeSelect: ['', Validators.required],
      typeCodeSelect: ['', Validators.required],
      typeInterventionSelect: ['', Validators.required],
      //typeActivitySelect: ['', Validators.required],
      activities: ['', Validators.required],
      description: [''],
      dateDebut: ['', Validators.required],
      dateFin: ['', Validators.required],
      taches: this.fb.array([]),
    }, { validators: this.dateRangeValidator('dateDebut', 'dateFin') });
  }

  loadProgrammes(): void {
    this.loadingProgrammeSelect = true;
    this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.programmes = (response.data || []).map((item: any) => ({ value: item.id, label: item.titre }));
        this.loadingProgrammeSelect = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des programmes :', error);
        this.loadingProgrammeSelect = false;
      }
    });
  }

  // Getter pour le FormArray des tâches
  get tachesFormArray(): FormArray {
    return this.generaleForm.get('taches') as FormArray;
  }

  get totalTaskWeight(): number {
    const total = this.tachesFormArray.controls.reduce((sum, task) => {
      return sum + (Number(task.get('poids')?.value) || 0);
    }, 0);

    return Math.round(total * 100) / 100;
  }

  get activityStartDate(): string | null {
    return this.toDateInputValue(this.generaleForm.get('dateDebut')?.value);
  }

  get activityEndDate(): string | null {
    return this.toDateInputValue(this.generaleForm.get('dateFin')?.value);
  }

  taskStartDate(index: number): string | null {
    return this.toDateInputValue(this.tachesFormArray.at(index).get('dateDebut')?.value);
  }

  taskEndDate(index: number): string | null {
    return this.toDateInputValue(this.tachesFormArray.at(index).get('dateFin')?.value);
  }

  private toDateInputValue(value: unknown): string | null {
    if (!value) return null;
    const valueAsString = String(value);
    return valueAsString.length >= 10 ? valueAsString.substring(0, 10) : valueAsString;
  }

  private dateRangeValidator(startControlName: string, endControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const start = this.toDateInputValue(control.get(startControlName)?.value);
      const end = this.toDateInputValue(control.get(endControlName)?.value);
      return start && end && start > end ? { dateOrder: true } : null;
    };
  }

  private taskDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const start = this.toDateInputValue(control.get('dateDebut')?.value);
      const end = this.toDateInputValue(control.get('dateFin')?.value);
      const activityStart = this.activityStartDate;
      const activityEnd = this.activityEndDate;

      if (!start || !end) return null;

      const errors: ValidationErrors = {};
      if (start > end) errors['dateOrder'] = true;
      if ((activityStart && start < activityStart) || (activityEnd && end > activityEnd)) {
        errors['outsideActivity'] = true;
      }

      return Object.keys(errors).length ? errors : null;
    };
  }

  private refreshTaskDateValidation(): void {
    this.tachesFormArray.controls.forEach(task => {
      task.updateValueAndValidity({ emitEvent: false });
    });
  }

  addTask(): void {
    if (!this.canAddTasks()) return;

    this.tachesFormArray.push(this.fb.group({
      titreTache: ['', Validators.required],
      dateDebut: ['', Validators.required],
      dateFin: ['', Validators.required],
      poids: ['', [Validators.required, Validators.min(0), Validators.max(100)]]
    }, { validators: this.taskDateValidator() }));
  }

  removeTask(index: number): void {
    this.tachesFormArray.removeAt(index);
  }

  // Méthode pour obtenir le label du type sélectionné
  getTypeLabel(): string {
    const selectedValue = this.generaleForm.get('typeCodeSelect')?.value;
    if (selectedValue) {
      const selectedType = this.types.find(t => t.value === selectedValue);
      return selectedType?.label || 'Parent';
    }
    return 'Parent';
  }

  // Méthode pour obtenir le label du type sélectionné
  getTypeLabelActivite(): string {
    const value = this.getNextTypeInterventionId();
    if (value) {
      const selectedType = this.types.find(t => t.value === value);
      return selectedType?.label || 'Activités';
    }
    return 'Activités';
  }

  // Fonction utilitaire pour aplatir la structure hiérarchique et ajouter l'ID du parent
  /* private flattenStructures(structures: StructureProgrammatiqueResponse[], parentId: string | null = null): StructureProgrammatiqueResponse[] {
    let flattened: StructureProgrammatiqueResponse[] = [];
    for (const structure of structures) {
      // Créer un nouvel objet pour éviter de modifier la structure originale si elle est immuable
      const currentStructure: StructureProgrammatiqueResponse = { ...structure, parent: parentId };
      flattened.push(currentStructure);
      if (structure.enfant && structure.enfant.length > 0) {
        flattened = flattened.concat(this.flattenStructures(structure.enfant, structure.id));
      }
    }
    return flattened;
  } */

  /*   loadStructures(): void {
      this.loadingStructures = true;
      this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
        next: (response: any) => {
          // Supposons que response.data est un tableau de structures de niveau supérieur avec des 'enfant' imbriqués
          this.structures = this.flattenStructures(response.data); // Aplatir et ajouter les ID des parents
           */

  /*this.loadTypeIntervention();
 this.translateToTypeActivite();

 // Après le chargement des structures, vérifier si nous avons une valeur dans le formulaire
 const typeInterventionSelectValue = this.generaleForm.get('typeInterventionSelect')?.value;
 if (typeInterventionSelectValue) {
   this.findHierarchy(typeInterventionSelectValue);
 } */

  /*       this.loadingStructures = false;
        },
        error: (error) => {
          console.error('Erreur lors du chargement des structures :', error);
          this.loadingStructures = false;
  
        }
      });
    } */

  loadTypeIntervention(): void {
    this.loadingTypes = true;
    this.typeInterventionService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
        this.types = this.typeInterventionData
          .filter((item: TypeInterventionResponse) => item.id !== 'PROGRAMME')
          .map((item: TypeInterventionResponse) => ({ value: item.id, label: item.libelle }));
        this.loadingTypes = false;

        //this.setLowestLevelTypeIntervention();
      },
      error: (error) => {
        console.error('Erreur lors du chargement des types intervention :', error);
        this.loadingTypes = false;
      }
    });
  }

  loadStructureConfiguration(): void {
    this.parametrageStructureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        const configurations = (response.data || []) as ParametrageStructureProgrammatiqueResponse[];
        this.configuredActivityTypeId = configurations.find(
          configuration => configuration.reference === 'STRUCTURE_PROGRAMMATIQUE'
        )?.valeur || null;
      },
      error: (error) => {
        console.error('Erreur lors du chargement de la configuration de la structure programmatique :', error);
        this.configuredActivityTypeId = null;
      }
    });
  }

  getNextTypeInterventionId(): string | null {
    const selectedTypeId = this.generaleForm.get('typeCodeSelect')?.value;
    const selectedType = this.typeInterventionData.find(type => type.id === selectedTypeId);
    if (!selectedType) return null;

    return this.typeInterventionData.find(type => type.niveau === selectedType.niveau + 1)?.id || null;
  }

  canAddTasks(): boolean {
    return this.getNextTypeInterventionId() === this.configuredActivityTypeId;
  }

  ngOnInit(): void {
    // Initialiser le formulaire avec les données reçues
    // this.loadStructures();
    this.loadTypeIntervention();
    this.loadProgrammes();
    this.loadStructureConfiguration();

    if (this.generalesData()) {
      this.generaleForm.patchValue(this.generalesData());
      // Si les données contiennent des tâches avec chronogrammes, les patcher
      if (this.generalesData().taches && Array.isArray(this.generalesData().taches)) {
        // Vider le FormArray existant avant de le remplir pour éviter les doublons
        while (this.tachesFormArray.length !== 0) {
          this.tachesFormArray.removeAt(0);
        }
        this.generalesData().taches.forEach((task: any) => {
          this.tachesFormArray.push(this.fb.group({
            titreTache: [task.titreTache, Validators.required],
            dateDebut: [task.dateDebut, Validators.required],
            dateFin: [task.dateFin, Validators.required],
            poids: [task.poids, [Validators.required, Validators.min(0), Validators.max(100)]]
          }, { validators: this.taskDateValidator() }));
        });
      }
    }

    // Supprimez l'appel à addChronogrammeCheckboxes() car les chronogrammes sont maintenant gérés par tâche
    // this.addChronogrammeCheckboxes();


    this.subscription.add(
      this.generaleForm.get('programmeSelect')?.valueChanges.subscribe(programmeId => {
        this.currentDescendants = [];
        this.resultatStructures = [];
        this.generaleForm.patchValue({ typeCodeSelect: '', typeInterventionSelect: '' }, { emitEvent: false });
        this.programme = null;
        this.objectif = null;
        if (!programmeId) return;
        this.structureProgrammatiqueService.getAllDescendants(this.appService.getAppId(), programmeId).subscribe({
          next: (response: any) => { this.currentDescendants = response.data || []; },
          error: (e) => console.error('Erreur récupération descendants du programme :', e)
        });
      })
    );

    // Utiliser .add() pour gérer plusieurs souscriptions avec un seul objet Subscription
    this.subscription.add(
      this.generaleForm.get('typeCodeSelect')?.valueChanges.subscribe(selectedId => {
        if (selectedId) {
          this.translateToTypeActivite(selectedId);
          this.programme = null;
          this.objectif = null;

          if (!this.canAddTasks()) {
            this.tachesFormArray.clear();
            this.taskWeightError = false;
          }
        }
      })
    );

    this.subscription.add(
      this.generaleForm.get('typeInterventionSelect')?.valueChanges.subscribe(selectedId => {
        if (selectedId) {
          this.findHierarchy(selectedId);
        } else {
          this.programme = null;
          this.objectif = null;
        }
      })
    );

    // Hide validation alert when form becomes valid
    this.subscription.add(
      this.generaleForm.statusChanges.subscribe(status => {
        if (status === 'VALID') {
          this.showValidationAlert = false;
          this.missingFields = [];
        }
      })
    );

    this.subscription.add(
      this.generaleForm.valueChanges.subscribe(() => {
        if (this.taskWeightError && (!this.canAddTasks() || this.totalTaskWeight === 100)) {
          this.taskWeightError = false;
        }
      })
    );

    this.subscription.add(
      this.generaleForm.get('dateDebut')?.valueChanges.subscribe(() => this.refreshTaskDateValidation())
    );
    this.subscription.add(
      this.generaleForm.get('dateFin')?.valueChanges.subscribe(() => this.refreshTaskDateValidation())
    );

    this.initializePrefilledSelection();
  }

  private initializePrefilledSelection(): void {
    const programmeId = this.generaleForm.get('programmeSelect')?.value;
    const typeCodeId = this.generaleForm.get('typeCodeSelect')?.value;
    const interventionId = this.generaleForm.get('typeInterventionSelect')?.value;
    if (!programmeId) return;

    this.structureProgrammatiqueService.getAllDescendants(this.appService.getAppId(), programmeId).subscribe({
      next: (response: any) => {
        this.currentDescendants = response.data || [];
        if (typeCodeId) this.translateToTypeActivite(typeCodeId);
        if (interventionId) this.findHierarchy(interventionId);
      },
      error: (e) => console.error('Erreur récupération descendants du programme :', e),
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /*   translateToResult(): void {
  
      this.resultatStructures = this.structures.filter(structure => structure.typeActivite === "RESULTATS" || structure.typeActivite === "RESULTAT").map((item: any) => ({
  
        value: item.id,
        label: item.titre
      }));
  
    } */

  translateToTypeActivite(type: any): void {
    this.resultatStructures = this.currentDescendants
      .filter((n: any) => n.typeActivite === type)
      .map((item: any) => ({ value: item.id, label: item.titre }));
  }

  findHierarchy(selectedId: string): void {
    this.programme = null;
    this.objectif = null;
    if (!selectedId) return;
    const appId = this.appService.getAppId();

    this.structureProgrammatiqueService.getLightById(appId, selectedId).subscribe({
      next: (response: any) => {
        const node = response.data;
        if (!node?.parent) return;
        this.structureProgrammatiqueService.getLightById(appId, node.parent).subscribe({
          next: (parentResponse: any) => {
            const parentNode = parentResponse.data;
            this.objectif = parentNode;
            if (parentNode?.parent) {
              this.structureProgrammatiqueService.getLightById(appId, parentNode.parent).subscribe({
                next: (grandParentResponse: any) => {
                  this.programme = grandParentResponse.data;
                },
                error: (e) => console.error('Erreur récupération programme parent :', e),
              });
            }
          },
          error: (e) => console.error('Erreur récupération objectif parent :', e),
        });
      },
      error: (e) => console.error('Erreur récupération hiérarchie :', e),
    });
  }

  onSubmitToLocalStorage(): void {
    // //console.log(this.generaleForm.value)
    //console.log("validiter du formm :" + this.generaleForm.valid)
    const hasInvalidTaskWeight = this.canAddTasks()
      && this.tachesFormArray.length > 0
      && this.totalTaskWeight !== 100;

    if (this.generaleForm.valid && !hasInvalidTaskWeight) {
      this.taskWeightError = false;
      const generalesFormValue = this.generaleForm.value;

      // Les tâches avec leurs chronogrammes sont déjà dans generalesFormValue.taches
      const formattedTaches = this.canAddTasks() ? generalesFormValue.taches : [];

      // Créez l'objet activity avec la structure souhaitée, en imbriquant tout dans 'generales'

      const type = this.getNextTypeInterventionId();

      const activityData = {
        generales: {
          ...generalesFormValue,
          taches: formattedTaches,
          // Le chronogramme global n'existe plus, il est maintenant par tâche
          // chronogramme: undefined, // Cette ligne n'est plus nécessaire
          dateDebut: formatDate(
            this.generaleForm.value.dateDebut,
            'yyyy-MM-ddTHH:mm:ss', 'en-US'
          ),
          dateFin: formatDate(
            this.generaleForm.value.dateFin,
            'yyyy-MM-ddTHH:mm:ss', 'en-US'
          ),

          programme: this.programme ? { id: this.programme.id, titre: this.programme.titre } : null,
          objectif: this.objectif ? { id: this.objectif.id, titre: this.objectif.titre } : null,
          type,
          // Les tâches sont déjà incluses dans generalesFormValue.taches
        },
      };

      // //console.log("activite ennnn : ",activityData)

      localStorage.setItem('activity', JSON.stringify(activityData));

      this.generalesChanges.emit({
        ...this.generaleForm.value, dateDebut: formatDate(
          this.generaleForm.value.dateDebut,
          'yyyy-MM-ddTHH:mm:ss', 'en-US'
        ),
        dateFin: formatDate(
          this.generaleForm.value.dateFin,
          'yyyy-MM-ddTHH:mm:ss', 'en-US'
        ),
        type
      });

      // Naviguer vers l'étape suivante
      //this.router.navigate([], { queryParams: { step: 'activites' } });
    } else {
      this.generaleForm.markAllAsTouched(); // Afficher les erreurs de validation
      this.missingFields = this.getMissingRequiredFields();
      this.taskWeightError = hasInvalidTaskWeight;
      if (hasInvalidTaskWeight) {
        this.missingFields.push(`Poids des tâches : total actuel ${this.totalTaskWeight} / 100`);
      }
      this.showValidationAlert = true;
      console.warn('Formulaire invalide. Veuillez remplir tous les champs requis.', this.missingFields);
    }
  }

  // Retourne la liste des champs requis manquants (labels utilisateur)
  private getMissingRequiredFields(): string[] {
    const missing: string[] = [];
    const controlsMap: { [key: string]: string } = {
      programmeSelect: 'Programme',
      typeCodeSelect: 'Type',
      typeInterventionSelect: this.getTypeLabel(),
      activities: 'Activités',
      dateDebut: 'Date de début',
      dateFin: 'Date de fin'
    };

    Object.keys(controlsMap).forEach(key => {
      const ctrl = this.generaleForm.get(key);
      if (ctrl && ctrl.invalid) {
        missing.push(controlsMap[key]);
      }
    });

    this.tachesFormArray.controls.forEach((task, index) => {
      if (task.invalid) {
        missing.push(`Tâche ${index + 1} : libellé, dates et poids`);
      }
    });

    return missing;
  }
}